import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {OntarioResponsibleGamingButtonsBox} from "./boxes/ontario.responsible-gaming-buttons.box";
import {OntarioSafeToPlayButtonComponent} from "./safe-to-play/ontario.safe-to-play-button.component";

interface OntarioResponsibleGamingButtonsComponentProps{
    isShownInHeader?: boolean
}

export const OntarioResponsibleGamingButtonsComponent = observer(class OntarioResponsibleGamingButtonsComponent extends OrbitComponent<OntarioResponsibleGamingButtonsComponentProps> {
    render() {
        const isShownInHeader = this.props.isShownInHeader ?? false;
        return (
            <OntarioResponsibleGamingButtonsBox>
                <OntarioSafeToPlayButtonComponent isShownInHeader={isShownInHeader}/>
            </OntarioResponsibleGamingButtonsBox>
        );
    }
});